import { apiSlice } from '../../app/api/apiSlice';
import { Product, ProductBaseOnCategory } from '../../types/product';
import { CreateNewProductResponse, GetProductResponse, GetProductsBaseOnCategoryIdResponse } from '../../types/response';

export const productApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllProduct: builder.query<Product[], void>({
            query: () => '/api/fnb/products',
            transformResponse: (response: GetProductResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Product', id: 'LIST' }],
        }),
        getProductsBaseOnCategory: builder.query<ProductBaseOnCategory[], number>({
            query: (categoryId: number) => `/api/fnb/categories/${categoryId}/products`,
            transformResponse: (response: GetProductsBaseOnCategoryIdResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Product', id: 'LIST' }],
        }),
        createNewProduct: builder.mutation<CreateNewProductResponse, FormData>({
            query: (FormData) => ({
                url: '/api/fnb/products',
                method: 'POST',
                body: FormData,
            }),
            invalidatesTags: [{ type: 'Product', id: 'LIST' }],
        }),
        updateProduct: builder.mutation<CreateNewProductResponse, { productID: number; data: FormData }>({
            query: ({ productID, data }) => ({
                url: `/api/fnb/products/${productID}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (result, error, { productID }) => [
                { type: 'Product', id: 'LIST' },
                { type: 'Product', id: productID },
            ],
        }),
    }),
});

export const { 
    useGetAllProductQuery,
    useGetProductsBaseOnCategoryQuery,
    useCreateNewProductMutation,
    useUpdateProductMutation,
} = productApiSlice;